import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M12.781 5.281l-8 8-.688.719.688.719 8 8 1.438-1.438L7.938 15h13.063c2.754 0 5 2.246 5 5v7h2v-7c0-3.844-3.156-7-7-7H7.938l6.281-6.281z" /></svg>);